<div class="d-flex justify-content-around">
  <p style="border-bottom: 1px solid var(--clr-red);" translate>user.connected</p>
  <p class="available-dms" *ngIf="!currentUser?.readOnlyPermissions" (click)="openAvailableImporters(dialogImporter)" translate>user.available</p>
</div>
<div>
  <div class="no-data-message" *ngIf="userImporters && !userImporters.length" translate>settings.noImporters</div>
  <ng-container *ngFor="let importer of userImporters">
    <div class="dms-container">
      <div class="d-flex justify-content-between">
        <div>
          <p  *ngIf="importer.importer.module === 'carconf'">{{'Car Configurator' | uppercase}} <span class="font-weight-bold"> (Api Key: 8afd5627-68bd-4d7c-bcf5-9b6a1f24623c)</span></p>
          <p *ngIf="importer.importer.module !== 'carconf'">{{importer.importer.name | uppercase}}</p>
          <!-- <p style="font-size: .8rem;">{{importer.importer.credentials.username}}</p> -->
        </div>
        <div class="row">
          <button class="btn btn-info mr-2" (click)="openEditImporter(dialogImporterConnect, importer)" translate>global.edit</button>
          <button class="btn btn-default disconnect" (click)="deleteUserImporter(importer)" translate>user.disconnect</button>
        </div>
      </div>
      <ng-container *ngIf="importer.importer.requiredFeatures && importer.importer.requiredFeatures.length > 0">
        <hr>
        <p><strong translate>settings.requiredFeatures</strong>:
          <span *ngFor="let feature of importer.importer.requiredFeatures" translate>
            {{ 'features.' + feature.name | translate }}
          </span>
        </p>
      </ng-container>
      <hr>
      <div class="d-flex justify-content-between">
        <div class="w-100">
          <p translate>Auto Import</p>
        </div>
        <div class="row">
          <app-general-settings-checkbox  mySelect  [defaultChecked]="importer?.autoImport" [checkType2]=true [data]="importer" (select)='patchAutoImport($event)'>
          </app-general-settings-checkbox>
          <!--div class="choose-window">
            <p translate>user.disable</p>
            <label class="switch">
              <input type="checkbox" [ngModel]="importer?.autoImport" (change)="patchAutoImport($event, importer)">
              <span class="slider round"></span>
            </label>
            <p translate>user.enable</p>
          </div-->
        </div>
      </div>

    </div>
  </ng-container>

</div>

<!-- Modal IMPORTER -->
<ng-template #dialogImporter let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>user.importers</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container *ngFor="let importer of importers">
      <div class="d-flex justify-content-between p-3">
        <p>{{importer.name}}</p>
        <button *ngIf="!importer?.isConnected" class="btn btn-default" (click)="openConnectImporterModal(dialogImporterConnect, importer)"
          translate>user.connect</button>
        <p class="connected-button" *ngIf="importer?.isConnected" translate>user.connected</p>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #dialogImporterConnect let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{selectedImporter.name}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #connectForm="ngForm">
      <div style="margin: 10px 0;" *ngFor="let field of selectedImporter.requiredFields">
        <label for="">{{getFieldLanguage(field.label)}}</label>
        <select *ngIf="field.type === 'select'" name="{{field.name}}"
          [ngModel]="selectedImporterCredentials ? selectedImporterCredentials[field.name] : field.default"
          class="form-control">
          <option *ngFor="let option of field.options" [value]="option.value">
            {{ getFieldLanguage(option.label) }}
          </option>
        </select>
        <div *ngIf="field.type === 'password'" class="password-field">
          <show-hide-password icon="fa fa-eye-slash" class="inputbotom">
            <input #userPassword="ngModel" name="{{field.name}}" type="password" class="form-control input-underline"
              [placeholder]="getFieldLanguage(field.label)"
              [ngModel]="selectedImporterCredentials ? selectedImporterCredentials[field.name] : field.default"
              required>
          </show-hide-password>
        </div>
        <input *ngIf="field.type === 'checkbox'" type="checkbox" class="form-control" name="{{field.name}}"
          [ngModel]="selectedImporterCredentials ? selectedImporterCredentials[field.name] : (field.default === 'true')">
        <input *ngIf="field.type !== 'select' && field.type !== 'password' && field.type !== 'checkbox'"
          type="{{field.type}}" class="form-control" name="{{field.name}}" [placeholder]="getFieldLanguage(field.label)"
          [ngModel]="selectedImporterCredentials ? selectedImporterCredentials[field.name] : field.default" required>
      </div>
      <button *ngIf="!selectedImporterCredentials" [disabled]="isConnecting" class="btn btn-default"
        (click)="connectToImporter(connectForm)" translate>user.connect</button>
      <button *ngIf="selectedImporterCredentials" class="btn btn-default" (click)="editUserImport(connectForm)"
        translate>global.edit</button>
    </form>
  </div>
</ng-template>